import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import OrderReducer from './OrderReducer';
import ProductReducer from './ProductReducer';
import CategoryReducer from './CategoryReducer';
import BlogReducer from './BlogReducer';
import SlidesReducer from './SlideshowReducer';
import MemberReducer from './MemberReducer';

const rootReducer = combineReducers({
    form: formReducer,
    order: OrderReducer,
    product: ProductReducer,
    category: CategoryReducer,
    blog: BlogReducer,
    slides: SlidesReducer,
    member: MemberReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js